<template>
  <div>
    <SettingsStatesSettings></SettingsStatesSettings>
  </div>
</template>

<script>
import SettingsStatesSettings from 'CORE/components/entity-states/settings/settings'

export default {
    name: 'SettingsStatesView',
    components: {
        SettingsStatesSettings,
    },
}
</script>
